exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1HSowMwvzLkqhKBEwxa2y8{width:300px}html[dir] ._2ngqnsmMTZS5v3sbKWRBFf{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"container": "_1HSowMwvzLkqhKBEwxa2y8",
	"fileProvidersToAddContainer": "_2ngqnsmMTZS5v3sbKWRBFf"
};